import { TFunction } from 'i18next';
import * as yup from 'yup';
import moment from 'moment';

interface Deadlines {
  fecFinalizacionActualizada?: string;
  fecFinalizacionInicial?: string;
}

const isOnTime = (fechasPlazos: Deadlines) => {
  const finishTime = fechasPlazos.fecFinalizacionActualizada
    ? moment(fechasPlazos.fecFinalizacionActualizada, 'DD/MM/YYYY')
    : moment(fechasPlazos.fecFinalizacionInicial, 'DD/MM/YYYY');
  return moment().isAfter(finishTime.clone().subtract(30, 'days'));
};

const ClassificationSchema = (t: TFunction<'translations'>, fechasPlazos: Deadlines) => yup.object({
  grupos: yup.array().of(
    yup.object({
      grupo: yup.object({
        codigo: yup.string().required({ text: `${t('details.validation.tab')} ${t('details.classification.tab')}: ${t('details.validation.noData')} "${t('details.classification.group')}"`, orden: 7}),
        nombre: yup.string().required({ text: `${t('details.validation.tab')} ${t('details.classification.tab')}: ${t('details.validation.noData')} "${t('details.classification.group')}"`, orden: 7}),
      }).required({ text: `${t('details.validation.tab')} ${t('details.classification.tab')}: ${t('details.validation.noData')} "${t('details.classification.group')}"`, tab: 'clasificacion', field: 'grupo', orden: 7 }),
      importeEstimado: yup.string().test(
        'Classification.estimatedBudget',
        { text: `${t('details.validation.tab')} ${t('details.classification.tab')}: ${t('details.validation.noData')} "${t('details.classification.estimatedBudget')}"`, tab: 'clasificacion', field: 'importeEstimado', orden: 7 },
        (value, context) => {
          return context.parent.origen === 'cecoc' || Boolean(value && value !== '');
        },
      ).nullable(),
      importeFinal: yup.string().test(
        'classification.finalBudget', 
        { text: `${t('details.validation.tab')} ${t('details.classification.tab')}: ${t('details.validation.beforeEndDate', {field: t('details.classification.finalBudget')})}`},
        (value) => value ? isOnTime(fechasPlazos): true).nullable(),
    })
  ).nullable(),
}).required();

export const ClassificationSchemaFinal = (t: TFunction<'translations'>) => yup.object({
  grupos: yup.array().of(
    yup.object({
      grupo: yup.object({
        codigo: yup.string().required({ text: `${t('details.validation.tab')} ${t('details.classification.tab')}: ${t('details.validation.noData')} "${t('details.classification.group')}"`, orden: 7}),
        nombre: yup.string().required({ text: `${t('details.validation.tab')} ${t('details.classification.tab')}: ${t('details.validation.noData')} "${t('details.classification.group')}"`, orden: 7}),
      }).required({ text: `${t('details.validation.tab')} ${t('details.classification.tab')}: ${t('details.validation.noData')} "${t('details.classification.group')}"`, tab: 'clasificacion', field: 'grupo', orden: 7 }),
      importeFinal: yup.string().nullable(),
    })
  ).required(),
}).required();

export default ClassificationSchema;
